<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    #profile.view
      bf-notice( :message='message' @close='message = ""' )

      transition( name='appear' )
        bf-wrapper.max-960
          profile-header( v-if='account.merchant' :account='account' )

          form.profile-form( @submit.prevent='update' )
            bf-flex.avatar.centered( @click.native='$refs.upload.click()' )
              input(type='file' ref='upload' style='display: none' accept='image/*' @change='upload( $event, "avatar" )')
              template( v-if='doc.avatar || account.avatar' )
                .image-container
                  img(:src='doc.avatar || account.avatar')
              template( v-else )
                bf-flex.upload-container.centered
                  img(src='/ui/profile.png')
                  span {{ $t('Add Image') }}

            .fields
              fieldset.span-1
                label {{ $t('Gender') }}*
                bf-input.gender.basic
                  select( v-model='doc.gender' )
                    optgroup.label
                      option.label(:value='undefined') {{ $t('Gender') }}
                    option( value='male' ) {{ $t('Male') }}
                    option( value='female' ) {{ $t('Female') }}

              fieldset.span-1
                label {{$t("Site Language")}}
                bf-input.locale.basic
                  select( v-model='doc.locale' )
                    optgroup.label
                      option( :value='undefined' ) {{ $t('Language') }}
                    option( value='en' ) English
                    option( value='es' ) Español
                    option( value='ch' ) 中文

              fieldset.span-2
                label {{ $t("Zip Code")}}*
                bf-input.zip.basic
                  input( v-model='doc.zip' type='zip' placeholder='Zip Code' required )

            bf-divider.borderless.section

            .fields
              fieldset.span-2
                label {{$t("Phone (Mobile)")}}*
                bf-input.phone-mbl.basic
                  input( type='phone' :placeholder='$t("Phone (Mobile)")' v-model='doc.phone' required )

              .span-2.dob
                label {{$t("Birthday (Year optional)")}}

                .dob-fields
                  .field.month
                    label {{$t("Month")}}*
                    bf-input.basic
                      input( type='number' v-model='dob.month' required min='1' max='12')

                  .field.date
                    label {{$t("Day")}}*
                    bf-input.basic
                      input( type='number' v-model='dob.date' required min='1' max='31' )
                    
                  .field.year
                    label {{$t("Year")}}
                    bf-input.basic
                      input( type='number' v-model='dob.year' )

            bf-divider.page.borderless

            .fields.name.address( v-if='!offer' )
              label {{$t("First Name")}}
              bf-input.address.basic.span-3
                input(type='text' v-model='name.first')

              label {{ $t("Last Name")}}
              bf-input.address.basic.span-3
                input(type='text' v-model='name.last')

              label {{ $t("Address")}}
              span.span-2 ({{ $t("Default Address for receiving services")}})
              bf-input.address.basic.span-3
                input(type='text' v-model='doc.address')

              bf-input.city.basic.span-1
                input(type='text' :placeholder='$t("City")' v-model='doc.city')

              bf-input.state.basic.span-1
                input(type='text' :placeholder='$t("State")' v-model='doc.state')

              bf-input.zip.basic.span-1
                input(type='text' :placeholder='$t("Zip Code")' v-model='doc.zip' name='zip')

            bf-divider.page.borderless

            .auth-fields.fields
              fieldset.span-2
                label {{ $t("Username")}}*
                bf-input.username.basic( :class='{ remind: !doc.username }' )
                  input( type='text' required v-model='doc.username' ref='username' )

              fieldset.span-2( :class='{ invalid: invalid }' )
                label {{$t("Email")}}*
                bf-input.name.basic
                  input( type='email' v-model='doc.email' )

              fieldset.field.span-2
                label {{$t("Password")}}
                bf-input.new-password.basic
                  input(type='password' v-model='password.current')

              fieldset.field.span-2
                label {{$t("Confirm Password")}}
                bf-input.confirm-password.basic
                  input(type='password' v-model='password.confirm')

            bf-divider.section

            bf-flex.centered.save-button-wrapper
              bf-button(type='submit')
                template(v-slot:text) {{ offer ? $t('Next') : $t('Save') }}

              bf-button.cancel(type='reset')
                template(v-slot:text) {{ offer ? $t('Clear') : $t('Cancel') }}

    bf-modal#business-modal(:show='!!modal.show')
      .container(v-if='modal.show === true')
        h4.heading {{ $t("Welcome to BlueFaucet") }}
        p {{ $t("Please fill in your information") }}
        p {{ $t("Your information is secured with us.  We will not share your information with other parties") }}
        p.primary.acknowledge-button(@click='acknowledge') {{ $t("ACKNOWLEDGE") }}
      .container(v-if='modal.show == "offer"')
        h4.heading Enable BlueFaucet Business Functions
        p During our beta test, we offer a one year FREE membership. Cancel anytime. After one year, it's only $29.99 per month.
        p Business functions include:
        ol
          li Manage your customer
          li Online realtime schedule
          li Marketing features with coupon, giftcard, membership, etc...
          li Many more to come...
        bf-flex.space-between.buttons
          span.skip.button(@click='skip') SKIP
          span.primary.button(@click='join') JOIN
</template>

<script>
  import { auth, db, firebase, str } from '@/main'
  import { View, Animatable } from '@/mixins/view'
  import { Doc } from '@/mixins/doc'
  import ProfileHeader from '@/components/profile-header'
  import Linkables from '@/components/buttons/linkables'

  export default {
    name: 'view.profile',

    components: {
      ProfileHeader,
      Linkables
    },

    props: ['user', 'account'],

    mixins: [ View, Doc, Animatable ],

    data() {
      return {
        type: 'Account',
        collection: 'accounts',
        password: {},
        message: '',
        offer: !!this.$route.params.offer,
        modal: { show: !!this.$route.params.offer },
        ready: false,
        prompt: false,
        invalid: false,
        key: 0
      }
    },

    watch: {
      account(curr, prev) {
        if ( curr.id ) {
          this.doc = curr
          this.dob = curr.dob || {}
        }
      }
    },

    methods: {
      linked( usr ) {
        this.key++
      },

      upload( e, field ) {
        let file = e.target.files[0]
        let reader  = new FileReader()
        reader.addEventListener('load', () => {
          const name = file.name
          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            let width = img.width
            let height = img.height
            let ratio = img.width / img.height
            if( img.width > 100 ) {
              width = 100
              height = width / ratio
            }
            else if ( img.height > 100 ) {
              height = 100
              width = height * ratio
            }
            const elem = document.createElement('canvas')
            elem.width = width
            elem.height = height
            const ctx = elem.getContext('2d')
            ctx.drawImage( img, 0, 0, width, height )
            ctx.canvas.toBlob( blob => {
              const file = new File([blob], name, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })

              let ref = str.ref( `/user/${this.user.uid}/logos/${file.name}` )
              ref.put(file).then( snap => {
                snap.ref.getDownloadURL().then( url => {
                  db.collection( 'accounts' ).doc( this.account.id ).update({
                    avatar: url
                  }).then( () => this.key++ )
                })
              }).catch( e => console.log(e) )
            }, 'image/jpeg', 1)
          }
          
        }, false)
        reader.readAsDataURL(file)
      },

      async set() {
        let snap = await db.collection('accounts').where( 'username', '==', this.doc.username ).get()
        let accounts = snap.docs
        let exists = accounts.find( a => a.data().username == this.doc.username && a.id != this.doc.id  )
        const actionSettingCode = { url: 'https://app.bluefaucet.com/' }
        if ( exists ) {
          this.message = this.$t('Username must be unique')
          this.doc.username = ''
          this.$refs.username.focus()
        }
        else {
          let idref = db.collection( this.collection ).doc( this.doc.id )
          if ( auth.currentUser.email != this.doc.email ) {
            auth.signInWithEmailAndPassword( auth.currentUser.email, this.password.current ).then( () =>
              auth.currentUser.updateEmail( this.doc.email ).then( usr => {
                auth.currentUser.sendEmailVerification(actionSettingCode)
                
                idref.set( this.doc ).then( doc => {
                  if ( !this.$route.params.offer ) {
                    this.$binding( 'doc', idref )
                    this.message = this.$t('Information Updated. Please note your new email when signing in:  ') + auth.currentUser.email
                  }
                  else this.$router.push('/')
                })
              }).catch( e => {
                this.invalid = true
                this.message = e.message 
              })
            ).catch( e => this.message = e.message )
          }
          else
            idref.set( this.doc ).then( doc => {
              if ( !this.account.merchant && this.$route.params.offer ) {
                if ( this.user.emailVerified) this.$route.push('/')
                else this.$router.push({ name: 'verify-email', params: { id: this.doc.id } }) 
              }
              else if ( !this.offer ) this.message = this.$t(`${this.type} information updated!`)
            })
        }
      },

      acknowledge() {
        this.modal.show = false
      },

      join() {
        this.doc.merchant = 'basic'
        this.set()
        this.$router.push({ name: 'business-profile', params: { thanks: true } })
      },

      skip() {
        this.$router.push({ name: 'welcome' })
        this.modal.show = false
      },

      mainpage() {
        this.modal.show = false
        this.$router.push({ name: 'welcome' })
      },

      merchantupgrade() {
        this.modal.show = false
        this.$router.push({ name: 'upgrade' })
      }
    },

    created() {
      if ( this.account.id ) {
        this.doc = this.account
        this.dob = this.account.dob || {}
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #profile.view
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type=number] {
      text-align center
      -moz-appearance: textfield;
    }

    .fields
      background white
      padding 10px
      box-shadow var(--shadow-box)
      border-radius 5px
      display grid
      grid-gap 16px
      grid-template-columns 1fr 1fr 1fr 1fr 
      &.address
        grid-template-columns 1fr 1fr 1fr
      @media( max-width: 640px )
        grid-template-columns 1fr 1fr
        .span-1, .span-2, .span-3, .span-4
          grid-column 1 / -1
      .span-2
        grid-column span 2
      .span-3
        grid-column span 3
      .span-4
        grid-column span 4
    
    fieldset .bf-input
      margin-top 8px
    
    .invalid .bf-input >>> .container
      border-color red
      background rgb( 250 240 240 )

    label 
      font-weight bold

    .dob-fields
      margin-top 8px
      display flex
      justify-content space-between

      label, .bf-input
        display inline-block
      label
        margin-right 8px
        font-weight normal
        color rgb( 128 128 128 )
      input
        width 20px
      .field.year input
        width 36px

  .save-button-wrapper .bf-button
    margin 0 12px

  .avatar
    margin 24px 0 16px 0
    .image-container
      width 88px
      height 88px
      img
        width 100%
        height 100%
        object-fit cover
        border 1px solid lightgray
        border-radius 50%
    .upload-container
      width 88px
      height 88px
      flex-direction column
      background rgb( 200 200 200 )
      border 1px solid lightgray
      border-radius 50%
      img
        width 20px
      span
        font-size .88em
        margin 8px 0
        font-weight bold

  h6
    padding 4px
    font-weight bold

  .forgot-password-link
    display block
    text-align right
    padding 8px 16px
    font-weight bold
    color var(--clr-blue)

  #modal
    position fixed
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 99
    background white
    align-items flex-start
    flex-direction column
    .close
      position absolute
      color white
      font-size 1.5em
      border 1px solid var(--clr-light)
      height 24px
      width 28px
      padding-bottom 4px
      display flex
      justify-content center
      border-radius 50%
      right 12px
      top 12px
    header
      position relative
      text-align center
      background var(--bg-nav)
      color white
      width 100%
      margin-bottom 24px
      padding 16px 0
      .heading
        color white
      img
        height 24px
    main
      width 320px
      margin 0 auto

  .bf-button.bright.wide
    margin 12px
</style>
